var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5553_66604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 57.8182H70.9839L101.314 75.3323L96.4961 83.6798L66.1657 66.1657L83.6798 96.4961L75.3323 101.314L57.8182 70.9839V106H48.1818V70.9839L30.6677 101.314L22.3202 96.4961L39.8343 66.1657L9.50386 83.6798L4.68568 75.3323L35.0161 57.8182H0V48.1818H35.0161L4.68568 30.6677L9.50386 22.3202L39.8343 39.8343L22.3323 9.50386L30.6798 4.68568L48.1939 35.0161V0H57.8302V35.0161L75.3323 4.68568L83.6798 9.50386L66.1657 39.8343L96.4961 22.3202L101.314 30.6677L70.9839 48.1818H106V57.8182Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5553_66604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon05);
export default __webpack_public_path__ + "static/media/icon_05.a62b2d51068b4ac729e995aaca09c398.svg";
export { ForwardRef as ReactComponent };